jQuery(document).ready(function($) {
  $('.gallery .owl-carousel').each((index,item) => {
		$(item).owlCarousel({
			loop: false,
            // rewind: true,
			margin:0,
			nav: true,
			dots: false,
			responsive:{
              0:{
                      items: 2.3,
                      margin:10,
                      slideBy: 1
              },
              989:{
                      items: 5.5,
                      margin:16,
                      slideBy: 6
              }
			}
		})
	})
});